import React from 'react'
import { Star, Quote } from 'lucide-react'

export const RavesPage: React.FC = () => {
  const testimonials = [
    {
      name: 'Grace & Jacob',
      venue: 'Grace Cathedral',
      rating: 5,
      text: 'Working with Duende Photo was an absolute dream. They captured our Grace Cathedral wedding with such artistry and emotion. Every photo tells the story of our love beautifully.',
      date: '2024'
    },
    {
      name: 'Erika & Denis',
      venue: 'San Francisco Engagement',
      rating: 5,
      text: 'Our engagement session in San Francisco was magical. The photographer understood our vision perfectly and created stunning images that we will treasure forever.',
      date: '2024'
    },
    {
      name: 'Kristen & Emre',
      venue: 'Stanford Memorial Church',
      rating: 5,
      text: 'The attention to detail and artistic vision exceeded all our expectations. Our Stanford wedding photos are breathtaking works of art.',
      date: '2023'
    },
    {
      name: 'Jessica & Dane',
      venue: 'Vine Hill House',
      rating: 5,
      text: 'From our first consultation to receiving our final gallery, the experience was seamless. The photos perfectly captured the romance of our Sebastopol wedding.',
      date: '2023'
    },
    {
      name: 'Susie & Reza',
      venue: 'Willow Heights Mansion',
      rating: 5,
      text: 'Professional, creative, and so easy to work with. Our Morgan Hill wedding photos are absolutely stunning. We could not be happier!',
      date: '2023'
    },
    {
      name: 'Amanda & Gordon',
      venue: 'Point Reyes Seashore Lodge',
      rating: 5,
      text: 'The natural, candid style perfectly captured our intimate wedding. Every moment was documented beautifully, creating memories we will cherish forever.',
      date: '2023'
    }
  ]

  return (
    <div className="min-h-screen">
      {/* Header */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 tracking-wide">
            Client Testimonials
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            Hear from couples who chose Duende Photo to capture their special moments
          </p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white p-8 shadow-sm border border-gray-100">
                <div className="mb-6">
                  <Quote className="w-8 h-8 text-gray-300 mb-4" />
                  <div className="flex mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                    ))}
                  </div>
                </div>

                <blockquote className="text-gray-700 leading-relaxed mb-6 italic">
                  "{testimonial.text}"
                </blockquote>

                <div className="border-t border-gray-100 pt-4">
                  <h4 className="font-light text-gray-900 text-lg">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600 mb-1">{testimonial.venue}</p>
                  <p className="text-xs text-gray-500">{testimonial.date}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-light text-gray-900 mb-6">
            Ready to Create Your Own Love Story?
          </h2>
          <p className="text-gray-600 mb-8 leading-relaxed">
            Join our family of happy couples and let us capture the magic of your special day.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/quote"
              className="px-8 py-3 bg-gray-900 text-white font-light tracking-wide hover:bg-gray-800 transition-colors duration-300"
            >
              Request a Quote
            </a>
            <a
              href="/portfolio"
              className="px-8 py-3 border border-gray-900 text-gray-900 font-light tracking-wide hover:bg-gray-900 hover:text-white transition-colors duration-300"
            >
              View Portfolio
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}
